import TheGrid from '@/views/campaigns/bestof/leaderobjectives/grid'
import Edit from '@/views/campaigns/bestof/leaderobjectives/edit'

export default {
  path: '/campaigns/bestof/leader-objectives',
  redirect: '/campaigns/bestof/leader-objectives/index',
  name: 'bestof_leaderobjectives',
  meta: {
    auth: {
      redirect: {
        name: 'bestof_leaderobjectives.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Bestof'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'bestof_leaderobjectives.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'bestof_leaderobjectives.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'bestof_leaderobjectives.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
